import React from 'react';
import { NombreMesCorto } from '../funciones/FuncionesFecha.js';

const SelectMes = (props) => {
  const mesActual = props.mesActual;
  let meses = [];
  for (let index = 0; index <= 11; index++) {
    meses = [...meses, NombreMesCorto(index)];
  }

  const onMesElegido = (event) => {
    const mesElegido = event.target.value === '' ? null : event.target.value;
    props.onMesElegido(mesElegido);
  };

  return (
    <select value={mesActual ? mesActual : ''} onChange={onMesElegido}>
      <option key="" value=""></option>
      {meses.map((mes, index) => (
        <option key={index} value={index + 1}>
          {mes}
        </option>
      ))}
    </select>
  );
};

export default SelectMes;
